// extracted by mini-css-extract-plugin
export default {"container":"Home_container__w+u63","top_section":"Home_top_section__phklN","bottom_section":"Home_bottom_section__6NTUD"};